import { Component } from '@angular/core';
import { NavController,NavParams,Platform,ActionSheetController,App,Events  } from 'ionic-angular';

import { WebService } from '../../../providers/service/webservice';
import { DELETETRIP } from '../../../providers/config/serviceurl';
import { StorageService } from '../../../providers/service/storageservice';
import { Utils } from '../../../providers/service/utils';
import { AppState } from '../../../app/app.global';

import { TripAddPage } from '../add/tripadd';
import { ToastAlert } from '../../../providers/util/toastalert';

@Component({
  selector: 'page-tripview',
  templateUrl: 'tripview.html'
})
export class TripView {
	currentUser:any;
	tripList:any[];//当月或者当周具体日程数据
	trip:any;
	selDay:string;//选中天
	st:string;
	et:string;
	reminds = [
		{id:'0',name:'永不'},
		{id:'5',name:'提前5分钟'},
		{id:'15',name:'提前15分钟'},
		{id:'30',name:'提前30分钟'},
		{id:'60',name:'提前1小时'},
		{id:'120',name:'提前2小时'},
		{id:'1440',name:'提前1天'},
		{id:'2880',name:'提前2天'},
		{id:'10080',name:'提前1周'}
	];
	reminds2 = [
		{id:'0',name:'永不'},
		{id:'5',name:'5分钟'},
		{id:'15',name:'15分钟'},
		{id:'30',name:'30分钟'},
		{id:'60',name:'1小时'},
		{id:'120',name:'2小时'},
		{id:'1440',name:'1天前'},
		{id:'2880',name:'2天前'},
		{id:'10080',name:'1周前'}
	];
	repeats = [
		{id:'0',name:'永不'},
		{id:'day',name:'每天'},
		{id:'week',name:'每周'},
		{id:'month',name:'每周'},
		{id:'year',name:'每年'}
	];
  constructor(public navCtrl: NavController,public params: NavParams, public platform: Platform,
    public actionsheetCtrl: ActionSheetController,private webService:WebService,private appCtrl :App,
  	public events: Events,public global: AppState,public toastAlert:ToastAlert) {
			this.trip =  params.data.trip;
			this.tripList = params.data.tripList;
			this.selDay = params.data.selDay;
			this.st = this.trip.timeStarts.substr(11,5);
			this.et = this.trip.timeEnds.substr(11,5);
			this.currentUser = StorageService.getObj("currentUser");
			this.trip.isBack=false;
  }
  //返回的时候可以执行 
  ionViewWillEnter(){
  	if(this.trip.isBack){
  		this.trip = Utils.rtSelArray(this.tripList,this.trip.id);
  		this.selDay = this.trip.timeStarts.substr(0,10);
  		this.trip.showETime = this.trip.timeEnds.substr(0,10);
  		if(this.trip.isAll!='1'){
  			this.trip.showETime =this.trip.showETime+'  '+this.trip.timeEnds.substr(11,5);
  			this.trip.showSTime = this.trip.timeStarts.substr(11,5);
  		}
  		this.trip.showETime += '结束';
  	}
  }
  
	openMenu() {
    let actionSheet = this.actionsheetCtrl.create({
      title: '删除后日程事件不能恢复。',
      buttons: [
        {
          text: '删除事件',
          role: 'destructive',
          icon: !this.platform.is('ios') ? 'trash' : null,
          handler: () => {
            this.deleteTrip();
          }
        },
        {
          text: '取消',
          role: 'cancel', 
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {
          }
        }
      ]
    });
    actionSheet.present();
  }
	
	editTrip(){
		this.trip.isAll2 = Utils.formatTrueOrFalse(this.trip.isAll);//转换下,修改新增是需要判断
		this.trip.repeat = Utils.rtSelArray(this.repeats,this.trip.repeatValue).name;
		this.trip.remind = Utils.rtSelArray(this.reminds2,this.trip.remindValue).name;
		this.appCtrl.getRootNav().push(TripAddPage,{ trip:this.trip,tripList: this.tripList });
	}
	
/*	goBack(){
		//this.events.publish('popsuccess','pop success 666');
		//this.appCtrl.getRootNav().push(TripPage);
		//this.navCtrl.getPrevious();
		this.navCtrl.pop();
		//this.navCtrl.popToRoot(TripPage);
	}*/
	
	//删除行程
  deleteTrip(){
  		var params = {'userId':this.currentUser.userId,'id':this.trip.id};
			this.webService.post(DELETETRIP,params,"删除日历行程").then(anyObj =>this.handleDelThings(anyObj));
  }
  //处理数据
  handleDelThings(obj :any){
		if(obj){
			if("yes"==obj.success){
				Utils.delArray(this.tripList,this.trip.id);
				this.toastAlert.alertMsg('删除成功','middle',1500);
			}else{
				this.toastAlert.alertMsg('删除失败','middle',1500);
			}
			this.events.publish('popsuccess','pop success 666');
			this.navCtrl.pop();
		}
	}
	
}



// WEBPACK FOOTER //
// ./src/pages/trip/tripview/tripview.ts